module.exports = __webpack_public_path__ + "img/extended.6ae50fd1.png";